<template>
  <!-- ************************************************** --
    -- 絞り込みダイアログ
    -- ************************************************** -->
    <!-- 乗務員チップ -->
    <v-dialog v-model="showDialog" height="80%" width="900" max-width="90%" style="z-index:500" persistent no-click-animation>
      <v-card>
        <v-toolbar elevation="1" color="#6091d3" dark dense>
          <v-spacer></v-spacer>
          <v-toolbar-title>乗務員情報絞り込み</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="onClickDriverFilterClose" text><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row no-gutters align-content="center" class="my-1">
              <div class="px-1" style="font-weight:bold;color:navy">入力した内容で絞り込みされます。</div>
            </v-row>
            <v-row no-gutters align-content="center" class="my-1">
              <v-col :cols="6">
                <v-row no-gutters align-content="center">
                  <v-col :cols="12" class="px-1">
                        <v-radio-group
                          label="乗務員種別"
                          v-model="driverFilterConditions.isOnlyJomuin"
                          row>
                          <dd-radio-button
                            style="width:25%"
                            label="乗務員のみ"
                            :value=true
                          />
                          <dd-radio-button
                            style="width:25%"
                            label="全員"
                            :value=false
                          />
                        </v-radio-group>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters align-content="center" class="my-1">
              <v-col :cols="3">
                <v-row no-gutters align-content="center">
                  <v-col :cols="12" class="px-1">
                    <dd-code-text-box
                      label="乗務員コード/名称"
                      v-model="driverFilterConditions.jininCd"
                      :length="100"
                      :valueType="Ctrls.InputTypes.Alphanumeric"
                      titleText="乗務員マスタ検索"
                      :headerList="mstJininHeaders"
                      item-value="jininCd"
                      item-text="jininNmSei"
                      :itemList="filteredJishaJininList"/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col :cols="6">
                <v-row no-gutters align-content="center">
                  <v-col :cols="12" class="px-1">
                    <dd-text-box
                      label="乗務員あいまい検索"
                      v-model="driverFilterConditions.jininNm"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters align-content="center" class="my-1">
              <v-col :cols="3">
                <v-row no-gutters align-content="center">
                  <v-col :cols="12" class="px-1">
                    <dd-code-text-box
                      label="所属営業所コード/名称"
                      v-model="driverFilterConditions.eigyoshoCd"
                      :length="100"
                      :valueType="Ctrls.InputTypes.Alphanumeric"
                      titleText="営業所マスタ検索"
                      :headerList="mstEigyoshoHeaders"
                      item-value="eigyoshoCd"
                      item-text="eigyoshoNm"
                      :itemList="filteredEigyoshoList"/>
                  </v-col>
                </v-row>
              </v-col>
              <v-col :cols="6">
                <v-row no-gutters align-content="center">
                  <v-col :cols="12" class="px-1">
                    <dd-text-box
                      label="所属営業所あいまい検索"
                      v-model="driverFilterConditions.eigyoshoNm"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickDriverFilterClose">閉じる</v-btn>
          <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickDriverFilterClear">クリア</v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickDriverFilterExec">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
// ----- <ここからJavaScript> ------------------------------------------------------------------------------------------------------------------------
//
//
// ************************************************************************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************************************************************************
//
//
//
// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'

// vue Definition
import { mapGetters } from 'vuex'

// DdComponents アルファベット順記述
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'DdHaishaDriverFilterDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    // DdCheckbox,
    DdCodeTextBox,
    // DdDataTable,
    // DdDateBox,
    // DdDefaultButton,
    // DdDropDown,
    // DdFooterButton,
    // DdIconButtonWithTooltip,
    // DdNumericBox,
    DdRadioButton,
    // DdSimpleTable,
    // DdSubHeader,
    // DdSubTitle,
    // DdSwitch,
    // DdTextArea,
    DdTextBox
    // DdTimeBox
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    param: {
      jininCd: '',
      jininNm: '',
      eigyoshoCd: '',
      eigyoshoNm: '',
      isOnlyJomuin: true
    }
  },

  data: () => ({
    invalidMessage: '',
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,

    // 乗務員フィルター初期値
    driverFilterConditions: {
      jininCd: '',
      jininNm: '',
      eigyoshoCd: '',
      eigyoshoNm: '',
      isOnlyJomuin: true
    },

    // 戻り値用定義
    rec: {
      id: 0
    }
  }),

  created () {
  },

  watch: {
    showDialog: function () {
      if (this.showDialog === true) {
        // ここに表示時やりたいこと書く
        this.driverFilterConditions = Object.assign({}, this.param)
      }
    }
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    this.initBindVariables()
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      eigyoshoList: 'DDMasters/mstEigyosho'
    }),

    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredVwcMstJinin () {
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredJishaJininList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.eigyoshoKbn !== '03'
      })
    }
  },

  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize: function () {
      // const self = this
      const opt = {
        loadMasters: [],
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onClickDriverFilterClose: function (e) {
      this.$emit('close', undefined)
    },
    onClickDriverFilterExec: function (e) {
      console.log(this.param)
      console.log(this.driverFilterConditions)
      this.$emit('exec', this.driverFilterConditions)
    },
    // --------------------------------------------------------------------------------
    // クリアボタン押下
    // --------------------------------------------------------------------------------
    onClickDriverFilterClear: function (e) {
      Object.assign(this.driverFilterConditions, this.$options.data().driverFilterConditions)
      this.$emit('exec', this.driverFilterConditions)
    }
  }
}
</script>
<style></style>
